module.exports = __webpack_public_path__ + "img/default-slika-za-tečajeve.369c98b7.jpg";